import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Header from './components/Heaer';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Team from './pages/Team';
import SubContractor from './pages/SubContractor';
const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/about" element={<About />} /> */}
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/Subcontractor" element={<SubContractor />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;